<app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>

<div class="row">
  <div class="col-md-12 mx-auto">
    <h3>Reporte del Mes de {{ month }} de {{ year }}</h3>
  </div>
  <hr />
  <div class="row">
    <div class="col-md-3 mb-3 form-floating">
      <div class="input-group">
        <input
          type="text"
          name="startDate"
          class="form-control"
          id="startDate"
          placeholder="Fecha inicial"
          ngbDatepicker
          #d="ngbDatepicker"
          [(ngModel)]="startDate"
          required
          readonly
          style="height: 3.5rem"
        />
        <button
          class="btn btn-outline-secondary bi bi-calendar3"
          (click)="onOpenToggle(d)"
          type="button"
        ></button>
      </div>
    </div>
    <div class="col-md-3 mb-3 form-floating">
      <div class="input-group">
        <input
          type="text"
          name="dateSession"
          class="form-control"
          id="endDate"
          placeholder="Fecha final"
          ngbDatepicker
          #d2="ngbDatepicker"
          [(ngModel)]="endDate"
          required
          readonly
          style="height: 3.5rem"
        />
        <button
          class="btn btn-outline-secondary bi bi-calendar3"
          (click)="onOpenToggle(d2)"
          type="button"
        ></button>
      </div>
    </div>
    <div class="col-md-1 mb-1 mt-1 form-floating">
      <button
        type="button"
        class="btn btn-primary btn-lg"
        (click)="onFilterData()"
      >
        Filtrar
      </button>
    </div>
    <div class="col-md-1 mb-1 mt-1 form-floating">
      <button
        type="button"
        class="btn btn-danger btn-lg"
        (click)="onResetFields()"
      >
        Reset
      </button>
    </div>
  </div>
  <hr />

  <div class="col-md-12">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th class="col">Fecha Venta</th>
          <th class="col text-center">Servicio</th>
          <th class="col text-center">Area Tratamiento</th>
          <th class="col text-center">MSI</th>
          <th class="col text-center">Precio Venta</th>
          <th class="col text-center">% Descuento</th>
          <th class="col text-center">Costo del Servicio</th>
          <th class="col text-center">Vendedor</th>
          <th class="col text-center">% Comision del Vendedor</th>
          <th class="col text-center">Comision del Vendedor</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let package of dataPackagesFilter">
          <td>{{ package.dateSell }}</td>
          <td>{{ package.service }}</td>
          <td>{{ package.areaSell }}</td>
          <td>{{ package.offer }}</td>
          <td>{{ package.price | currency }}</td>
          <td>{{ package.areaDiscount }}</td>
          <td>{{ package.priceService | currency }}</td>
          <td>{{ package.seller }}</td>
          <td>{{ package.percentageSellerCommission }} %</td>
          <td>{{ package.commissionSeller | currency }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
